import {PathOptions} from 'leaflet';

/**
 * One look for "what changed on the route", shared by the voyage sync window and the template
 * editor: green now, light blue before, orange changed, yellow added, red removed.
 */
export const ROUTE_CHANGE_COLOR = {
	newRoute: '#1D9E75',
	newRouteArrow: '#0F6E56',
	oldRoute: '#38A8E8',
	changed: '#E07A10',
	added: '#F6C445',
	removed: '#E24B4A',
}

export const HALO_RADIUS_ROUTE_CHANGE = 18
export const RING_RADIUS_ROUTE_CHANGE = 7

export const ROUTE_CHANGE_PATH: Record<string, PathOptions> = {
	newRoute: {color: ROUTE_CHANGE_COLOR.newRoute, weight: 3},
	// wide and pale, drawn under the new route
	oldRoute: {color: ROUTE_CHANGE_COLOR.oldRoute, weight: 9, opacity: 0.5},
	// dashed, so the route underneath still shows where the change runs over it
	changed: {color: ROUTE_CHANGE_COLOR.changed, weight: 4, dashArray: '10 8'},
	// joins a moved stop to where it stood
	connector: {color: ROUTE_CHANGE_COLOR.oldRoute, weight: 3, dashArray: '6 6'},
	movedHalo: {stroke: false, fillColor: ROUTE_CHANGE_COLOR.changed, fillOpacity: 0.3},
	oldHalo: {stroke: false, fillColor: ROUTE_CHANGE_COLOR.oldRoute, fillOpacity: 0.3},
	oldRing: {color: ROUTE_CHANGE_COLOR.oldRoute, weight: 3, fillColor: '#FFFFFF', fillOpacity: 1},
	removedRing: {color: ROUTE_CHANGE_COLOR.removed, weight: 3, fillColor: '#FFFFFF', fillOpacity: 1},
}
